import { render, staticRenderFns } from "./CallData.vue?vue&type=template&id=490da704&"
import script from "./CallData.vue?vue&type=script&lang=js&"
export * from "./CallData.vue?vue&type=script&lang=js&"
import style0 from "./CallData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports